import React, { Component, useRef } from 'react';
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import CompanyAssetFunctions from '../services/CompanyAssetService';
import InstrumentFunctions from '../services/InstrumentService'
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort, FaRegEdit, FaRegTrashAlt, FaRegFilePdf } from 'react-icons/fa'
import '../layout/site.css';
import '../layout/print.css'
import Modal from 'react-bootstrap/Modal';
import Moment from 'react-moment';

export class CompanyAssets extends Component {
    static displayName = CompanyAssets.name;

    constructor(props) {
        super(props);

        this.inputRef = React.createRef();

        this.state = {
            search: null,
            assets: [],
            history: [],
            assetsOrig: [],
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
            manufacturer: '',
            toolDescription: '',
            modelNum: '',
            sizeRange: '',
            serialNum: '',
            noOfPieces: '',
            loading: false,
            noResults: false,
            currentPage: 1,
            itemsPerPage: 100,
            numberOfPages: 0,
            showToast: false,
            showPopup: false,
            showAddAsset: false,
            selectedAsset: {},
            assetId: '',
            showHistory: false,
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveAsync = this.handleSaveAsync.bind(this);
        this.handleAddAsset = this.handleAddAsset.bind(this);
        this.handleEditAsset = this.handleEditAsset.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleClosePopup = this.handleClosePopup.bind(this);
        this.handleDeleteAsync = this.handleDeleteAsync.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    handleAddAsset() {
        var selected = {
            id: '',
            manufacturer: '',
            description: '',
            model: '',
            range: '',
            serialNo: '',
            qty: '',
        }
        this.setState({ selectedAsset: selected, showAddAsset: true });
    }

    handleEditAsset(id) {
        var filtered = this.state.assets.filter(asset => {
            return asset.id == id;
        });

        if (filtered.length != 0) {
            var asset = filtered[0];

            var selected = {
                id: asset.id,
                manufacturer: asset.manufacturer,
                description: asset.description,
                model: asset.description,
                range: asset.range,
                serialNo: asset.serialNo,
                qty: asset.qty,
            }

            this.setState({ selectedAsset: selected, showAddAsset: true });
        }
    }

    handleClose() {
        this.setState({ showToast: false, showPopup: false, showAddAsset: false, showHistory: false });
    }

    handleClosePopup() {
        this.setState({ showPopup: false });
    }

    handleClick(event) {
        let id = Number(event.target.id);

        if (id === 0) {
            this.setState({
                currentPage: 1
            });
        } else if (id === -1) {
            this.setState({
                currentPage: Math.ceil(this.state.assets.length / this.state.itemsPerPage)
            });
        } else {
            this.setState({
                currentPage: Number(event.target.id)
            });
        }
    }

    handleChange(event) {
        this.setState({ currentPage: Number(event.target.value) });
    }

    handlePageSizeChange(event) {
        let pageSize = Number(event.target.value);
        this.setState({ itemsPerPage: pageSize });
        if (this.state.currentPage > Math.ceil(this.state.assets.length / pageSize)) {
            this.setState({ currentPage: Math.ceil(this.state.assets.length / pageSize) })
        }
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";

        const isAdmin = await AdminFunctions.isAdminAsync();
        this.setState({ isAdmin: isAdmin });
        if (isAdmin) {

        }
        else {
        }
        this.getAssetData();
    }

    async getAssetData() {
        var response = await CompanyAssetFunctions.getCompanyAssetsAsync();

        if (response.status == 200) {
            var assets = await response.json();

            if (assets != null) {
                var original = assets.slice(0);
                this.setState({ assets: assets, assetsOrig: original });
            }
        }
    }

    handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.searchAssets();
        }
    }

    async handleSubmission(assetId, fileData) {
        const formData = new FormData();

        formData.append('File', fileData);
        formData.append('assetId', assetId);

        this.setState({ uploading: true });

        var response = await CompanyAssetFunctions.postCertificateUploadAsync(formData);

        if (response != null) {
            this.setState({ uploading: false });
            this.getAssetData();
        }
    };


    async handleDeleteAsync(id) {
        var assets = this.state.assets;

        var filtered = assets.filter(asset => {
            return asset.id === id;
        });

        if (filtered.length != 0) {
            var asset = filtered[0];
            asset.delete = true;

            var response = await CompanyAssetFunctions.postSaveCompanyAssetAsync(asset);

            if (response.status == 200) {
                var assets = await response.json();

                if (assets != null) {
                    var original = assets.slice(0);
                    this.setState({ assets: assets, assetsOrig: original });
                }
            }
        }
    }

    async handleSaveAsync() {
        var manufacturer = this.state.selectedAsset.manufacturer;
        var description = this.state.selectedAsset.description;
        var model = this.state.selectedAsset.model;
        var size = this.state.selectedAsset.range;
        var serialno = this.state.selectedAsset.serialNo;
        var pieces = this.state.selectedAsset.qty;

        if (manufacturer === "")
            manufacturer = "N/A";
        if (description === "")
            description = "N/A";
        if (model === "")
            model = "N/A";
        if (size === "")
            size = "N/A";
        if (serialno === "")
            serialno = "N/A";
        if (pieces === "")
            pieces = "N/A"

        if (manufacturer != "" && description != "" && model != "" && size != "" && serialno != "" && pieces != "") {
            var dto = {
                id: this.state.selectedAsset.id,
                manufacturer: manufacturer,
                description: description,
                model: model,
                serialNo: serialno,
                range: size,
                qty: pieces
            };

            var response = await CompanyAssetFunctions.postSaveCompanyAssetAsync(dto);

            if (response.status == 200) {
                var assets = await response.json();

                if (assets != null) {
                    var original = assets.slice(0);
                    this.setState({ assets: assets, assetsOrig: original });
                }
            }
        }
        this.handleClose();
    }

    async getCertificateFile(assetCertId, fileName) {
        var certificate = await CompanyAssetFunctions.getCertificateFileAsync(assetCertId);

        if (certificate != null) {
            if (certificate.ok == true && certificate.status == 200) {
                certificate.blob().then((data) => {
                    console.log(data);
                    var url = window.URL.createObjectURL(data);
                    var anchor = document.createElement("a");

                    anchor.href = url;
                    anchor.filename = `${fileName}.pdf`;
                    anchor.target = '_blank';
                    anchor.click();
                    setTimeout(function () {
                        window.URL.revokeObjectURL(url);
                    }, 0);
                }).catch((error) => {
                    console.log(error);
                    this.setState({ toastTitle: 'Download Error!', toastBody: 'There was an error downloading the selected Cert!', showToast: true });
                });
            } else if (certificate.status == 204) {
                this.setState({ toastTitle: 'Cert Unavailable!', toastBody: 'The selected Cert could not be located!', showToast: true });
            }
        }
    }

    render() {
        // Logic for displaying instruments!
        const indexOfLastItem = this.state.currentPage * this.state.itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - this.state.itemsPerPage;
        const currentItems = this.state.assets.slice(indexOfFirstItem, indexOfLastItem);

        const renderItems = currentItems.map((asset, i) => {
            return (
                <tr key={i}>
                    <td>
                        {(asset.certs != null && asset.certs.length != 0) ?
                            <a href="#" onClick={(e) => {
                                e.preventDefault();
                                this.getCertificateFile(asset.certs[0].id, asset.certs[0].originalFileName);
                            }}>View</a>
                            : 'N/A'
                        }
                    </td>
                    <td>
                        {(asset.certs != null && asset.certs.length != 0) ?
                            <a href="#" onClick={(e) => {
                                this.setState({ history: asset.certs, showHistory: true });
                                e.preventDefault();
                            }}>Show</a>
                            : 'N/A'
                        }
                    </td>
                    <td>{asset.manufacturer}</td>
                    <td>{asset.model}</td>
                    <td>{asset.serialNo}</td>
                    <td>{asset.description}</td>
                    <td>{asset.range}</td>
                    <td>{asset.qty}</td>
                    <td>
                        <label for={'file-upload-' + asset.id} class="custom-file-upload">
                            <FaRegFilePdf
                                title='Upload Certificate'
                                className='action-icon'
                            />
                        </label>
                        <input id={'file-upload-' + asset.id} style={{ display: 'none' }} type="file" onChange={(e) => {
                            this.handleSubmission(asset.id, e.target.files[0]);
                        }} />
                    </td>
                    <td>
                        <FaRegEdit
                            title='Edit Asset'
                            className='action-icon'
                            onClick={() => this.handleEditAsset(asset.id)}
                        />
                    </td>
                    <td>
                        <FaRegTrashAlt
                            title='Delete Asset'
                            className='action-icon'
                            onClick={() => this.handleDeleteAsync(asset.id)}
                        />
                    </td>
                </tr>
            )
        });

        const renderHistory = this.state.history.map((assetCert, i) => {
            return (
                <tr key={i}>
                    <td style={{ textAlign: 'center' }}><a href="javascript:void(0)" onClick={(e) => this.getCertificateFile(assetCert.id, assetCert.originalFileName)}>View</a></td>
                    <td style={{ textAlign: 'center' }}>{assetCert.originalFileName}</td>
                    <td style={{ textAlign: 'center' }}>{assetCert.addedBy}</td>
                    <td style={{ textAlign: 'center' }}>{assetCert.dateAdded != null && <Moment format="M/D/YYYY">{assetCert.dateAdded}</Moment>}</td>
                </tr>
            )
        });


        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.state.assets.length / this.state.itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        const renderPageNumbers = pageNumbers.map(number => {
            return (
                <option value={number}>{number}</option>
            );
        });

        return (
            <>
                <div className='content-area'>
                    <Container>
                        <Row>
                            <Col>
                                <h2 style={{ color: '#233c7c' }}>Add Company Assets</h2>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Input
                                    tabIndex='3'
                                    type='text'
                                    className='fullInput'
                                    onChange={(e) => this.setState({ search: e.target.value })}
                                    onKeyPress={(e) => this.handleKeyPress(e)}
                                    placeholder='Manufacturer, Model #, Serial #, Description'
                                />
                            </Col>
                            <Col className='buttonCol' style={{ maxWidth: '125px' }}>
                                <Button
                                    tabIndex='4'
                                    color='primary'
                                    style={{ width: '125px' }}
                                    className='standardButton'
                                    onClick={() => this.searchAssets()}
                                    disabled={this.state.loading ? true : false}
                                >
                                    Search
                                </Button>
                            </Col>
                            <Col className='buttonCol' style={{textAlign: 'right'}}>
                                <Button
                                    tabIndex='5'
                                    color='primary'
                                    className='standardButton'
                                    onClick={() => this.handleAddAsset()}
                                    disabled={this.state.loading ? true : false}
                                >
                                    Add Instrument
                                </Button>
                            </Col>
                        </Row>
                        {this.state.assets.length !== 0 && (
                            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        )}
                        <Row style={{ marginTop: '20px' }}>
                            <Col xl='12' lg='12' md='12' sm='12' xs='12'>
                                <Table responsive>
                                    <thead>
                                        <tr>
                                            <th>
                                                Cert
                                            </th>
                                            <th>
                                                History
                                            </th>
                                            <th>
                                                Manufacturer
                                                <FaSort
                                                    color={this.state.sort.column === 'manufacturer' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('manufacturer')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Model #
                                                <FaSort
                                                    color={this.state.sort.column === 'model' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('model')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Serial #
                                                <FaSort
                                                    color={this.state.sort.column === 'serialNo' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('serialNo')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Tool Description
                                                <FaSort
                                                    color={this.state.sort.column === 'description' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('description')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                Size / Range
                                                <FaSort
                                                    color={this.state.sort.column === 'range' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('range')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                                # of Pieces
                                                <FaSort
                                                    color={this.state.sort.column === 'qty' ? '#0a58ca' : 'black'}
                                                    onClick={() => this.handleSort('qty')}
                                                    className='sort-button'
                                                />
                                            </th>
                                            <th>
                                            </th>
                                            <th>
                                            </th>
                                            <th>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.loading === true && this.state.loadingDocument === false ? (
                                            <tr>
                                                <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <Spinner color="primary" children='' />
                                                </td>
                                            </tr>

                                        ) : (
                                            <>
                                                {!this.state.noResults ? (
                                                    <>
                                                        {renderItems}
                                                    </>
                                                ) : (
                                                    <tr>
                                                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                            <h5>No Results Found</h5>
                                                        </td>
                                                    </tr>
                                                )}
                                            </>
                                        )}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                        {this.state.assets.length !== 0 && (
                            <div style={{ display: 'flex', justifyContent: 'right', alignItems: 'right', textAlign: 'center', marginTop: '20px', marginBottom: '50px' }}>
                                <label style={{ marginRight: '10px', marginTop: '5px' }}>Page</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.currentPage} onChange={this.handleChange}>
                                    {renderPageNumbers}
                                </select>
                                <label style={{ marginRight: '10px', marginLeft: '10px', marginTop: '5px' }}>Page Size</label>
                                <select className='form-control' style={{ width: '75px' }} value={this.state.itemsPerPage} onChange={this.handlePageSizeChange}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>

                            </div>
                        )}
                    </Container>
                    <Modal show={this.state.showToast} onHide={this.handleClose}>
                        <Modal.Header >
                            <Modal.Title>Email Sent!</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Thank you for requesting a quote for calibration.  A <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span> team member is working on your quote.
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.showPopup} onHide={this.handleClosePopup} dialogClassName="modelWidth">
                        <Modal.Header >
                            <Modal.Title>Email Sent!</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div>Thank you for contacting <span style={{ color: '#233c7c', fontWeight: 'bold' }}>TICMS</span>, your file has been sent for our review!</div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className='standardButton btn btn-primary' onClick={this.handleClosePopup}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.showAddAsset} onHide={this.handleClose}>
                        <Modal.Header >
                            <Modal.Title>{this.state.selectedAsset.id === '' ? 'Add' : 'Edit'} Company Asset</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Col>
                                <Row>
                                    <Col>
                                        <Input
                                            tabIndex='10'
                                            type='text'
                                            name='Manufacturer'
                                            id='Manufacturer'
                                            className='fullInput'
                                            value={this.state.selectedAsset.manufacturer}
                                            onChange={(e) => {
                                                var selected = this.state.selectedAsset;
                                                selected.manufacturer = e.target.value;
                                                this.setState({ selectedAsset: selected });
                                            }}
                                            placeholder='Manufacturer'
                                        />
                                    </Col>
                                    <Col>
                                        <Input
                                            tabIndex='11'
                                            type='text'
                                            name='ToolDescription'
                                            id='ToolDescription'
                                            className='fullInput'
                                            value={this.state.selectedAsset.description}
                                            onChange={(e) => {
                                                var selected = this.state.selectedAsset;
                                                selected.description = e.target.value;
                                                this.setState({ selectedAsset: selected });
                                            }}
                                            placeholder='Tool Description'
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <Input
                                                    tabIndex='12'
                                                    type='text'
                                                    name='ModelNum'
                                                    id='ModelNum'
                                                    className='fullInput'
                                                    value={this.state.selectedAsset.model}
                                                    onChange={(e) => {
                                                        var selected = this.state.selectedAsset;
                                                        selected.model = e.target.value;
                                                        this.setState({ selectedAsset: selected });
                                                    }}
                                                    placeholder='Model #'
                                                />
                                            </Col>
                                            <Col>
                                                <Input
                                                    tabIndex='13'
                                                    type='text'
                                                    name='SizeRange'
                                                    id='SizeRange'
                                                    className='fullInput'
                                                    value={this.state.selectedAsset.range}
                                                    onChange={(e) => {
                                                        var selected = this.state.selectedAsset;
                                                        selected.range = e.target.value;
                                                        this.setState({ selectedAsset: selected });
                                                    }}
                                                    placeholder='Size / Range'
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col>
                                                <Input
                                                    tabIndex='14'
                                                    type='text'
                                                    name='SerialNum'
                                                    id='SerialNum'
                                                    className='fullInput'
                                                    value={this.state.selectedAsset.serialNo}
                                                    onChange={(e) => {
                                                        var selected = this.state.selectedAsset;
                                                        selected.serialNo = e.target.value;
                                                        this.setState({ selectedAsset: selected });
                                                    }}
                                                    placeholder='Serial #'
                                                />
                                            </Col>
                                            <Col>
                                                <Input
                                                    tabIndex='15'
                                                    type='text'
                                                    name='NumPieces'
                                                    id='NumPieces'
                                                    className='fullInput'
                                                    value={this.state.selectedAsset.qty}
                                                    onChange={(e) => {
                                                        var selected = this.state.selectedAsset;
                                                        selected.qty = e.target.value;
                                                        this.setState({ selectedAsset: selected });
                                                    }}
                                                    placeholder='# of Pieces (if applicable)'
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            </Col>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                tabIndex='16'
                                variant="secondary" className="standardButton btn btn-primary" onClick={this.handleClose}>
                                Close
                            </Button>
                            <Button
                                tabIndex='17'
                                variant="primary" className="standardButton btn btn-primary" onClick={this.handleSaveAsync}>
                                {this.state.selectedAsset.id === '' ? 'Add' : 'Save'}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                    <Modal show={this.state.showHistory} onHide={this.handleClose}>
                        {/*TODO: Add closeButton to Header... and get it to display!*/}
                        <Modal.Header >
                            <Modal.Title>Certificate History</Modal.Title>
                        </Modal.Header>
                        <Modal.Body><Table responsive>
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'center' }}>
                                        Cert
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        File
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Added By
                                    </th>
                                    <th style={{ textAlign: 'center' }}>
                                        Date Added
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading === true && this.state.loadingDocument === false ? (
                                    <tr>
                                        <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', minHeight: '50vh', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                            <Spinner color="primary" children='' />
                                        </td>
                                    </tr>

                                ) : (
                                    <>
                                        {!this.state.noResults ? (
                                            <>
                                                {renderHistory}
                                            </>
                                        ) : (
                                            <tr>
                                                <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', position: 'absolute', top: '50%', left: '50%', marginTop: '-50px', marginLeft: '-50px' }}>
                                                    <h5>No Results Found</h5>
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )}
                            </tbody>
                        </Table>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button className='standardButton btn btn-primary' onClick={this.handleClose}>
                                Close
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </div>
           </>
        )
    }

    // instruments

    async searchAssets() {
        var assets = this.state.assetsOrig;
        var search = this.state.search;

        if (search != null && search != "") {
            assets = assets.filter(function (asset) {
                return (asset.manufacturer.includes(search) || asset.model.includes(search) || asset.serialNo.includes(search) || asset.description.includes(search));
            });
        }

        this.setState({ assets: assets });
    }

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.assets;
        data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            assets: data,
            sort: {
                column,
                direction
            }
        })
    }
}